import { useMutation } from '@tanstack/react-query';
import { type FormEvent, useState } from 'react';

import { api } from '../api/endpoints';
import { Modal } from '../components/Modal';
import { MutationError } from '../components/MutationError';
import { useAuth } from './context';

// PasswordGate: Nach einem Startpasswort (z. B. per E-Mail erhalten) legt der Benutzer vor der Arbeit sein eigenes
// Passwort fest. Ohne neues Passwort bleibt nur Abmelden; nach dem Speichern meldet er sich neu an (die Änderung
// beendet aus Sicherheitsgründen alle Sitzungen).
export function PasswordGate() {
  const { logout } = useAuth();
  const [form, setForm] = useState({ current: '', next: '', repeat: '' });
  const mismatch = form.repeat !== '' && form.next !== form.repeat;
  const save = useMutation({
    mutationFn: () => api.changePassword(form.current, form.next),
    onSuccess: () => void logout(),
  });
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!mismatch) save.mutate();
  };
  return (
    <Modal title="Eigenes Passwort festlegen" dismissible={false}>
      <form onSubmit={submit}>
        <p>Sie haben sich mit einem Startpasswort angemeldet. Bitte legen Sie jetzt Ihr eigenes Passwort fest – nur Sie kennen es. Danach melden Sie sich einmal mit dem neuen Passwort an.</p>
        <div className="form-grid">
          <label className="field wide">
            <span>Startpasswort</span>
            <input type="password" value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} autoComplete="current-password" required data-autofocus />
          </label>
          <label className="field">
            <span>Neues Passwort (mind. 10 Zeichen)</span>
            <input type="password" value={form.next} minLength={10} onChange={(e) => setForm({ ...form, next: e.target.value })} autoComplete="new-password" required />
          </label>
          <label className="field">
            <span>Neues Passwort wiederholen</span>
            <input type="password" value={form.repeat} onChange={(e) => setForm({ ...form, repeat: e.target.value })} autoComplete="new-password" required aria-invalid={mismatch} />
          </label>
        </div>
        {mismatch && <p className="field-error">Die Passwörter stimmen nicht überein.</p>}
        {save.isError && <MutationError error={save.error} />}
        <div className="modal-actions">
          <button type="button" className="btn" onClick={() => void logout()}>
            Abmelden
          </button>
          <button type="submit" className="btn btn-primary" disabled={save.isPending}>
            Passwort speichern
          </button>
        </div>
      </form>
    </Modal>
  );
}
